import { Dropdown, MenuProps } from 'antd';
import React, { useState } from 'react';
import { BaseButton, Icon } from '@common/components';
import {
  SummaryPdfExportModal,
  HoursExportModal,
  DisputesExportModal,
} from '@pay-bill/components';

export const BillingDownloadsDropdown = ({
  id,
  isSupplier,
}: {
  id: string;
  isSupplier: boolean;
}) => {
  const [modalVisible, setModalVisible] = useState<string | undefined>();

  const entityType = isSupplier ? 'reverse_invoice' : 'invoice';

  const dropdownMenuItems = [
    {
      label: 'Summary PDF',
      key: 'summary-pdf',
    },
    {
      label: 'Hours',
      key: 'hours',
    },
    {
      label: 'Disputes',
      key: 'disputes',
    },
  ];

  const onClick: MenuProps['onClick'] = ({ key }) => {
    setModalVisible(key);
  };

  const onAction = () => {
    setModalVisible(undefined);
  };

  return (
    <>
      <Dropdown
        menu={{
          items: dropdownMenuItems,
          onClick,
        }}
      >
        <BaseButton>
          <Icon icon="arrowDownToBracket" kind="regular" />
          Downloads
          <Icon icon="chevronDown" size="sm" kind="regular" />
        </BaseButton>
      </Dropdown>
      <SummaryPdfExportModal
        id={id}
        entityType={entityType}
        visible={modalVisible === 'summary-pdf'}
        onAction={onAction}
      />
      <HoursExportModal
        id={id}
        entityType={entityType}
        visible={modalVisible === 'hours'}
        onAction={onAction}
      />
      <DisputesExportModal
        id={id}
        entityType={entityType}
        visible={modalVisible === 'disputes'}
        onAction={onAction}
      />
    </>
  );
};
